import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <p className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.28em] ${dark ? "text-[#8A5A00]" : "text-[#FFB000]"}`}>
    <span className="h-px w-8 bg-current" />
    {children}
  </p>
);
